import { useState } from "react";
import { BadgeCheck } from "lucide-react";
import { RARITY_STYLE } from "@/lib/constants";
import { ProductImage } from "@/components/shop/ProductImage";

export const isHighValue = (p) => p.category === "singole" && p.price > 200;

export const ProductGallery = ({ p }) => {
  const photos = [p.image, ...(p.gallery || [])].filter(Boolean);
  const [i, setI] = useState(0);
  const cur = photos[Math.min(i, photos.length - 1)];
  return (
    <div>
      <div className="relative overflow-hidden rounded-3xl border border-black/10 bg-[#FFFFFF]">
        <ProductImage src={cur} alt={p.name} w={900} width={900} height={1125} eager sizes="(min-width: 1024px) 50vw, 100vw" className="aspect-[4/5] w-full object-cover" testid="product-image" />
        {p.rarity && <span className={`absolute left-4 top-4 rounded-lg px-3 py-1 text-xs font-bold ${RARITY_STYLE[p.rarity]}`}>{p.rarity}</span>}
      </div>
      {photos.length > 1 && (
        <div className="mt-3 flex gap-2 overflow-x-auto" data-testid="product-gallery">
          {photos.map((src, k) => (
            <button key={src} onClick={() => setI(k)} data-testid={`product-thumb-${k}`}
              className={`h-20 w-16 shrink-0 overflow-hidden rounded-lg border-2 transition-colors ${k === i ? "border-amber-500" : "border-black/10 hover:border-black/30"}`}>
              <ProductImage src={src} w={300} width={64} height={80} className="h-full w-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const AuthenticityNote = ({ p, cond }) => (
  <div className="mt-4 rounded-2xl border-2 border-emerald-600/40 bg-emerald-50 p-4 text-sm" data-testid="product-authenticity">
    <p className="flex items-center gap-2 font-display font-bold text-emerald-800"><BadgeCheck className="h-5 w-5" />Carta originale verificata</p>
    <p className="mt-1 text-stone-700">Condizione: <b data-testid="product-authenticity-condition">{cond || "indicata in negozio"}</b>{p.language ? ` · ${p.language}` : ""}</p>
    <p className="mt-1 text-stone-600">Ogni carta di alto valore è controllata a mano dal nostro staff prima della vendita. Chiedici pure altre foto della carta prima dell'acquisto. Viene spedita assicurata, in sleeve e toploader.</p>
  </div>
);
